import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"
import {individualReport} from "../apiConfigs"

export const IndividualContentApi = createAsyncThunk(
    'auth/analytics/IndividualContentApi',
    async (requestData, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(individualReport, { params: requestData })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const IndividualContentSlice = createSlice({
    name: 'analytics/IndividualContentApi',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(IndividualContentApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(IndividualContentApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(IndividualContentApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const IndividualContentReducer = IndividualContentSlice.reducer